import { Injectable } from '@angular/core';
import { IStorage } from '@/core/interface/storage-service.interface';
import { SessionStatus } from '@/core/model/session-status';
import { STORAGE_KEYS } from '@/share/constant/storage_token.key';
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class StorageService implements IStorage {
    private prefixedKey(key: string): string {
        return `${environment.appKeyPrefix}:${key}`;
    }

    get<T>(key: string, _local = false): T | null {
        const raw = (_local ? localStorage : sessionStorage).getItem(this.prefixedKey(key));
        if (raw === null) return null;
        try {
            return JSON.parse(raw) as T;
        } catch {
            return raw as unknown as T;
        }
    }
    set<T>(key: string, value: T, _local = false): void {
        (_local ? localStorage : sessionStorage).setItem(this.prefixedKey(key), JSON.stringify(value));
    }

    remove(key: string, local = false): void {
        (local ? localStorage : sessionStorage).removeItem(this.prefixedKey(key));
    }
    clearAll(): void {
        // localStorage.clear();
        sessionStorage.clear();
    }
}
